import {ACard} from "@atiautomacao/ati-ui-library";
import React, {FunctionComponent, useState} from "react";
import {
    Box,
    Divider,
    Modal, Stack,
    Tooltip,
    Typography,
} from "@mui/material";
import {
    ExportDinDexLossesReactQuery,
    FindUnavailabilityPowerStationsReactQuery
} from "./reactQuery/UnavailabilityReactQuery";
import IconButton from "@mui/material/IconButton";
import {InfoOutlined, SimCardDownloadOutlined} from "@mui/icons-material";
import FullscreenOutlinedIcon from '@mui/icons-material/FullscreenOutlined';
import ExpandedUnavailabilityChart from "./components/ExpandedUnavailabilityChart";
import UnavailabilityBarChart from "./components/UnavailabilityBarChart";
import themeDefaults from "../../../Shared/Theme/ThemeDefaults";
import {useSnackbar} from "notistack";
import {
    buildDateFilterValidationMessage,
    validateAndConvertDateFilters
} from "../../../Utils/AlarmDateFilterValidationUtils";

const UnavailabilityByPowerStationCard: FunctionComponent<{startDateTime:string, endDateTime:string}> = ({startDateTime, endDateTime}) => {
    const {data} = FindUnavailabilityPowerStationsReactQuery(startDateTime, endDateTime)
    const mutate = ExportDinDexLossesReactQuery()
    const [open, setOpen] = useState(false);
    const {enqueueSnackbar} = useSnackbar();

    const validateExportPeriod = (): {startDateTime: string; endDateTime: string} | null => {
        const validationResult = validateAndConvertDateFilters([
            {name: "startDateTime", condition: "starts-at", value: startDateTime || "", sort: "none"},
            {name: "endDateTime", condition: "ends-at", value: endDateTime || "", sort: "none"},
        ]);

        if (!startDateTime || !endDateTime || !validationResult.isValid) {
            enqueueSnackbar(buildDateFilterValidationMessage(validationResult.invalidFieldLabels), {variant: 'error'});
            return null;
        }

        return {
            startDateTime: validationResult.filters[0].value,
            endDateTime: validationResult.filters[1].value,
        };
    };

    const handleExport = (format: "csv" | "excel") => {
        const validPeriod = validateExportPeriod();
        if (!validPeriod) return;

        mutate.mutate({
            format,
            startDateTime: validPeriod.startDateTime,
            endDateTime: validPeriod.endDateTime,
        });
    };

    return (
        <>
            <ACard
                ariaLabel={"dashboard-station-inverter-power-x-irradiance"}
                key={`chart-power-irradiance`}
                styleProps={{
                    cardStyle: { height: 485 },
                    contentStyle: { padding: '0 16px', height: 408 },
                    subTitleStyle: { display: 'none'},
                }}
                headerControlsPosition={"header"}
                title={"Indisponibilidade DIN/DEX por Usina"}
                headerActions={
                    <Stack sx={{width: '100%', marginRight: 6}} direction="column" spacing={"2px"}>
                        <Box sx={{ width: '100%', display: 'flex',alignItems: 'center', justifyContent: 'space-between', padding: '0 5px'}}>
                            <IconButton   onClick={() => {setOpen(true)}}  sx={{borderRadius: '4px', width: '100%', justifyContent: 'flex-start'}} disabled={false} size="small" >
                                <FullscreenOutlinedIcon sx={{marginRight: '12px'}}/>
                                <Typography variant="body2" >Ver em tela cheia</Typography>
                            </IconButton>
                        </Box>
                        <Divider />
                        <Box onClick={() => handleExport("csv")} sx={{ width: '100%', display: 'flex',alignItems: 'center', justifyContent: 'space-between', padding: '0 5px'}}>
                            <IconButton size="small"  sx={{borderRadius: '4px', width: '100%', justifyContent: 'flex-start'}}>
                                <SimCardDownloadOutlined sx={{marginRight: '12px'}}/>
                                <Typography variant="body2">Baixar como CSV</Typography>
                            </IconButton>
                        </Box>
                        <Divider />
                        <Box onClick={() => handleExport("excel")} sx={{ width: '100%', display: 'flex',alignItems: 'center', justifyContent: 'space-between', padding: '0 5px'}}>
                            <IconButton size="small"  sx={{borderRadius: '4px', width: '100%', justifyContent: 'flex-start'}}>
                                <SimCardDownloadOutlined sx={{marginRight: '12px'}}/>
                                <Typography variant="body2">Baixar como Excel</Typography>
                            </IconButton>
                        </Box>
                        <Divider />
                    </Stack>
                }
                InformationTooltip={
                    <Stack direction="column" spacing={"2px"}>
                        <Tooltip describeChild title="Mostra a perda energética por usina no período, de forma segmentada por DIN e DEX." arrow placement={'top-end'}>
                            <InfoOutlined fontSize='small' style={{backgroundColor: themeDefaults.colors.primary,color: 'white', borderRadius: '50%', border: '1px solid rgba(45, 93, 231, 1)',}}/>
                        </Tooltip>
                    </Stack>
                }
            >
                {data &&
                    <UnavailabilityBarChart data={data}/>
                }
            </ACard>
            <Modal
                open={open}
                onClose={() => {setOpen(false)}}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <ExpandedUnavailabilityChart startDateTime={startDateTime} endDateTime={endDateTime} onClose={() => {setOpen(false)}}/>
            </Modal>
        </>

    );
}

export default UnavailabilityByPowerStationCard;
